import React from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';

export const SearchLoadingTable = ({ columns, sub }) => {
  const dataSource = [
    { id: 1, name: 'name1' },
    { id: 2, name: 'name2' },
    { id: 3, name: 'name3' },
    { id: 4, name: 'name4' },
    { id: 5, name: 'name5' },
    { id: 6, name: 'name6' },
    { id: 7, name: 'name7' },
    { id: 8, name: 'name8' },
    { id: 9, name: 'name9' },
  ];

  const subDataSource = [
    { id: 1, name: 'name1' },
    { id: 2, name: 'name2' },
    { id: 3, name: 'name3' },
  ];

  return (
    <React.Fragment>
      <Table
        dataSource={sub ? subDataSource : dataSource}
        columns={columns}
        pagination={
          sub
            ? false
            : {
                position: 'both',
                simple: true,
              }
        }
      />
    </React.Fragment>
  );
};

SearchLoadingTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      dataIndex: PropTypes.string,
      key: PropTypes.string,
    }),
  ),
  sub: PropTypes.bool,
};

export default SearchLoadingTable;
